import useMutationApi from 'src/api/useMutationApi';

interface ApiResponse {
  success: boolean;
}

interface CreateOutboundSellSuggestionNotificationParams {
  customerId?: string;
  unitVariationId?: string;
  suggestedQuantity?: number;
}

const useCreateOutboundSellSuggestionNotification = (
  onSuccess?: () => void,
) => {
  return useMutationApi<
    CreateOutboundSellSuggestionNotificationParams | void,
    ApiResponse
  >({
    endpoint: 'qa/create-outbound-sell-suggestion',
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useCreateOutboundSellSuggestionNotification;
